import React, { useEffect } from 'react';
import { unstable_batchedUpdates as batchedUpdates } from 'react-dom';
import CircularProgress from '@material-ui/core/CircularProgress';
import Box from '@material-ui/core/Box';
import * as qs from 'qs';
import { getVendingMachineInfo } from '../api/api';
import { useVendingMachine } from '../contexts/VendingMachineContext';
import { useUser } from '../contexts/UserContext';
import { getStickerSlaveId } from '../utils/slaveSelection';
import {useTheme} from "../contexts/ThemeContext";

const LoadVendingMachineInfo = ({ location, history }) => {
  const {
    setStickerId, vendingMachineInfo,
    setVendingMachineInfo, stickerId,
    setStickerSlaveId, setConfirmedSlaveId,
  } = useVendingMachine();
  const { loggedIn } = useUser();
  const { s } = qs.parse(location.search, { ignoreQueryPrefix: true });
  const { theme } = useTheme();

  useEffect(() => {
    (async () => {
      let vmInfo;
      if (s) {
        try {
          // Load vending machine information
          vmInfo = await getVendingMachineInfo(s);
        } catch (e) {
          history.push('/');
        }
        // A freshly loaded machine starts a new visit: its sticker binding, nothing confirmed yet.
        // Batched, as React 16 does not batch after an await and VMView may already be mounted
        batchedUpdates(() => {
          setStickerId(s);
          setStickerSlaveId(getStickerSlaveId(vmInfo?.vendingMachineSlaves));
          setConfirmedSlaveId(null);
          setVendingMachineInfo(vmInfo);
        });
      }
    })();
  }, []);

  useEffect(() => {
    if (vendingMachineInfo !== undefined) {
/*      if (!loggedIn) {
        history.push(`/?s=${stickerId}`);
        return;
      }*/
      history.push(`/home?s=${stickerId}`);
    }
  }, [vendingMachineInfo]);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      margin="auto"
    >
      <CircularProgress style={{ color: theme.loadingIconColor }} />
    </Box>
  );
};

export default LoadVendingMachineInfo;
